import { CartLineResponse, CartResponse } from './cart.response';
import { CartLineState, CartState } from './cart.state';

/** Pure wire → state mappers for the cart endpoints. */

export function mapCartLineResponse(response: CartLineResponse): CartLineState {
  return {
    ...response,
    addedAt: new Date(response.addedAt)
  };
}

export function mapCartResponse(response: CartResponse): CartState {
  return {
    ...response,
    lines: response.lines.map(mapCartLineResponse),
    savedForLater: response.savedForLater.map(mapCartLineResponse)
  };
}
